export default __webpack_public_path__ + "static/media/strawberry.b64626dd.ogg";